import { render, staticRenderFns } from "./credit_quota_detail.vue?vue&type=template&id=0e0b36e1&scoped=true&"
import script from "./credit_quota_detail.vue?vue&type=script&lang=js&"
export * from "./credit_quota_detail.vue?vue&type=script&lang=js&"
import style0 from "./credit_quota_detail.vue?vue&type=style&index=0&id=0e0b36e1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0b36e1",
  null
  
)

export default component.exports